import React from "react";
import PerformanceAnalysisTabs from "./PerformanceAnalysisTabs";
import { compareRanks } from "@ugg/shared/dist/utils/rank-helpers";
import { getRiotAssetsContext } from "@outplayed/riot-assets";

const PerformanceAnalysisHeader = (props) => {
  const { getProfileIconImg, getChampionSplashImg } = getRiotAssetsContext();
  const { playerInfo, soloRankScore, flexRankScore, mostPlayedChamps, summonerName, howlingAbyssTopThree } = props;
  const findTopRoleId = () => {
    if (mostPlayedChamps.length > 0) {
      if (mostPlayedChamps[0].topChamps[0].gamesPlayed > mostPlayedChamps[1].topChamps[0].gamesPlayed)
        return mostPlayedChamps[0].topChamps[0].championId;
      return mostPlayedChamps[1].topChamps[0].championId;
    } else if (howlingAbyssTopThree.length > 1) {
      const howlingAbyssTopThreeSorted = howlingAbyssTopThree.sort((champ1, champ2) => {
        return champ2.gamesPlayed - champ1.gamesPlayed;
      });
      return howlingAbyssTopThreeSorted[0].championId;
    } else {
      return 1;
    }
  };

  let greaterRank;

  if (flexRankScore && soloRankScore) {
    const rankOne = {
      tier: soloRankScore.tier,
      rank: soloRankScore.rank,
      wins: soloRankScore.wins,
      losses: soloRankScore.losses,
    };

    const rankTwo = {
      tier: flexRankScore.tier,
      rank: flexRankScore.rank,
      wins: flexRankScore.wins,
      losses: flexRankScore.losses,
    };

    greaterRank = compareRanks(rankOne, rankTwo);
  } else if (flexRankScore || soloRankScore) {
    greaterRank = flexRankScore || soloRankScore;
  } else {
    greaterRank = { tier: "unranked" };
  }

  const tabs = [
    {
      label: "STATS",
      callback: () => {
        scrollToHandler(document.querySelector(".your-stats"));
      },
    },
    {
      label: "CHAMPIONS",
      callback: () => {
        scrollToHandler(document.querySelector(".champion-breakdown"));
      },
    },
    {
      label: "POSITIONS",
      callback: () => {
        scrollToHandler(document.querySelector(".position-breakdown"));
      },
    },
    {
      label: "FRIENDS",
      callback: () => {
        scrollToHandler(document.querySelector(".team-players"));
      },
    },
  ];

  const scrollToHandler = (targetNode) => {
    if (targetNode) {
      const targetRect = targetNode.getBoundingClientRect();
      const masthead = document.querySelector("#masthead");
      const mastheadRect = masthead.getBoundingClientRect();
      window.scrollBy({ top: targetRect.top - mastheadRect.bottom - 80, behavior: "smooth" });
    }
  };

  const headerStyle = {
    backgroundImage: `
      linear-gradient(180deg, rgba(7, 7, 32, 0.44) 0%, #070720 100%),
      url(${getChampionSplashImg(findTopRoleId())})
    `,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  };

  return (
    <div className="performance-analysis_header-section" style={headerStyle}>
      <div className="profile-icon-container">
        <img className="profile-icon" src={getProfileIconImg(playerInfo.iconId)} />
        <img
          className="rank-border"
          src={`https://static.bigbrain.gg/assets/lol/rank_borders/round-without-level/border-${greaterRank.tier.toLowerCase()}.svg`}
        />
      </div>
      <div className="summoner-name">{summonerName.toUpperCase()}</div>
      <img
        className="year-in-review-image"
        width={455}
        src="https://static.bigbrain.gg/assets/lol/performance_analysis/images/L20-YIR.svg"
      />
      <img width={142} src="https://static.bigbrain.gg/assets/ugg/logo/ugg-logo.svg" />
      <PerformanceAnalysisTabs tabsData={tabs} sticky defaultIndex={-1} />
      <img
        className="long-down-arrow"
        src="https://static.bigbrain.gg/assets/lol/performance_analysis/icons/long_down_arrow.svg"
        onClick={() => scrollToHandler(document.querySelector(".your-stats"))}
      />
    </div>
  );
};

export default PerformanceAnalysisHeader;
